import React, { useState } from 'react'

import microphone from '../microphone'

import Layout from '../components/Layout'
import RecordSteps from './RecordSteps'
import Button from '../components/Button'
import ActionBar from '../components/ActionBar'

const Record = ({ step, onStart, onStop, isRecording }) => {
  const [isReady, setReady] = useState(false)

  const onClickReady = () => {
    setReady(true)
    setTimeout(onStart, 3000)
  }

  const onClickStop = () => {
    setReady(false)
    onStop()
  }

  return (
    <Layout key={step}>
      <RecordSteps isReady={isReady} isRecording={isRecording} step={step} />

      <ActionBar active>
        {!isRecording && (
          <Button fullWidth onClick={onClickReady} disabled={isReady}>
            Start
          </Button>
        )}

        {isRecording && (
          <Button fullWidth onClick={onClickStop} disabled={!isRecording}>
            Stop
          </Button>
        )}
      </ActionBar>
    </Layout>
  )
}

let timeoutForPause = null

export default ({ onDone, addBlob }) => {
  const [isRecording, setRecording] = useState(false)
  const [step, setStep] = useState(1)

  const onStart = () => {
    setRecording(true)

    microphone.startRecording()

    timeoutForPause = setTimeout(microphone.pauseRecording, 25000)
  }

  const onStop = () => {
    setRecording(false)

    timeoutForPause && clearTimeout(timeoutForPause)

    const recordings = ['sentence', 'cough', 'breath']

    microphone
      .stopRecording()
      .then(blob => addBlob(recordings[step - 1], blob))
      .then(() => {
        if (step === 3) {
          microphone.destroy()

          return onDone()
        }

        setStep(step + 1)
      })
  }

  return (
    <Record
      step={step}
      onStart={onStart}
      onStop={onStop}
      isRecording={isRecording}
    />
  )
}
